<template>
    <BaseDialog
        :visible="dialog"
        :type="type"
        :form="form"
        title="uživatele"
        @close="dialog=false"
        @process="processForm"
    >
        <v-text-field
                v-model="form.username"
                type="text"
                label="Uživatelské jméno"
                :rules="formRules.username"
        />
        <v-text-field
                v-model="form.firstName"
                type="text"
                label="Jméno"
        />
        <v-text-field
                v-model="form.lastName"
                type="text"
                label="Příjmení"
        />
        <v-text-field
                v-model="form.email"
                type="text"
                label="E-mail"
        />
        <v-text-field
                v-model="form.password"
                type="text"
                label="Heslo"
                persistent-hint
                :hint="passwordHint"
                class="mb-5"
                :rules="passwordRules"
        />

        <CzDatePicker v-model="form.validUntil" label="Platnost" />

        <v-checkbox dense hide-details
                v-model="form.isActive"
                label="Aktivní"
        />
        <v-checkbox dense hide-details
                v-model="form.isSuperuser"
                label="Administrátor"
        />
    </BaseDialog>
</template>

<script>
    import BaseDialogMixin from '../../mixins/BaseDialogMixin'

    export default {
        mixins: [BaseDialogMixin],

        data: () => ({
            form: {
                id: 0,
                username: '',
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                isActive: false,
                isSuperuser: false,
                validUntil: '',
            },
            formRules: {
                event_id: [v => v > 0 || 'Vyberte událost'],
                username: [v => v !== '' || 'Vyplňte hodnotu'],
                email: [v => v !== '' || 'Vyplňte hodnotu']
            }
        }),

        methods: {
            postShow () {
                if (this.type === 'edit') {
                    setTimeout( () => {
                        if (this.detail.profile) {
                            this.form.validUntil = this.detail.profile.validUntil
                        } else {
                            this.form.validUntil = ''
                        }
                    }, 100)
                }
            }
        },

        computed: {
            passwordHint () {
                return this.type === 'edit' ? 'Pokud zadáte heslo, bude u uživatele změneno' : ''
            },
            passwordRules () {
                return [v => {
                    if (this.type==='edit') {
                        return true
                    } else {
                        return v !== '' || 'Vyplňte hodnotu'
                    }
                }]
            }
        }
    }
</script>
